import { render, staticRenderFns } from "./dui-file-upload.vue?vue&type=template&id=218b51f0&"
import script from "./dui-file-upload.vue?vue&type=script&lang=js&"
export * from "./dui-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./dui-file-upload.vue?vue&type=style&index=0&id=218b51f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports